<template>
	<el-table
			v-if=" !loading &&tableData.length > 0 "
			height="100%"
			:data="tableData"
			style="width: 100%">
		<el-table-column
				fixed
				prop="name"
				label="名称"
				width="220"
		>
		</el-table-column>

		<el-table-column
			fixed
			prop="total"
			:label="'总用'+type.name+'量'"
			width="180">
			<!-- <template slot-scope="scope">
				<template  v-if="node=='water'">
					<template v-if="scope.row.id!=30">
						--
					</template>
					<template v-else>
						{{scope.row.total}}<span v-if="node=='electricity'">kWh</span><span v-else-if="node=='water'">m³</span><span v-else>GJ</span>
					</template>
				</template>
				<template  v-else>
					{{scope.row.total}}<span v-if="node=='electricity'">kWh</span><span v-else-if="node=='water'">m³</span><span v-else>GJ</span>
				</template>
			</template> -->
		</el-table-column>

		<el-table-column
			v-for="(item, index) in titles"
			:key="index"
			:prop="item"
			min-width="110"
			:label="item">
			<!-- <template slot-scope="scope" >
				<template v-if="node=='water'">
					<template v-if="scope.row.id!=30">
						--
					</template>
					<template v-else>
						{{scope.row[item]}}<span v-if="scope.row[item]!='--'"><span v-if="node=='electricity'">kWh</span><span v-else-if="node=='water'">m³</span><span v-else>GJ</span></span>
					</template>
				</template>
				<template v-else>
					{{scope.row[item]}}<span v-if="scope.row[item]!='--'"><span v-if="node=='electricity'">kWh</span><span v-else-if="node=='water'">m³</span><span v-else>GJ</span></span>
				</template>
			</template>
			 -->
		</el-table-column>

	</el-table>
	<div v-else class="row-center tip">
		<img v-if="loading" src="../../../assets/img/loading.png" class="loading">
		<img v-else src="../../../assets/img/not_found_data.png" alt="">
	</div>
</template>

<script>
	import {floatFormat} from "../../../util/MathUtil"
	import {currentDay, monthDays,weekStart,weekEnd,dateFormat} from "../../../util/DateUtil";
	import {classifiedEnergyConsumption} from "../../../api/power";
	import exportExcel from "../../../util/excel";
	import Axios from "axios"
	import dict from "../../../util/dict"
	import ExcelJS from 'exceljs'
	import FileSaver from 'file-saver'
	export default {
		props: {
			loops: Array,
			range: String,
			date: Date,
			node:String
		},
		name: "Running",
		data() {
			return {
				loading: false,
				titles: [],
				tableData:[],
				timeDate:"",
				// type:"电",
				list:[
					{
						name:"电",
						unit:"kWh",
						class:"electricity"
					},
					{
						name:"水",
						unit:"m³",
						class:"water"
					},
					{
						name:"热",
						unit:"GJ",
						class:"heat"
					},
					{
						name:"冷",
						unit:"GJ",
						class:"cooling"
					}
				]
			}
		},
		mounted() {
			this.requestData();
			switch (this.range) {
				case "day":
					this.titles = []
					for (let i = 0; i < 24; i++) {
						this.$set(this.titles, i, i + '点')
					}
					break;
				case "month":
					this.titles = []
					for (let i = 0; i < monthDays(this.date); i++) {
						this.$set(this.titles, i, i + 1 + '日')
					}
					break;
				case "week":
					this.titles = []
					let startDate = weekStart(this.date).replace('T00:00:00Z',"")
					let endDate = weekEnd(this.date).replace('T00:00:00Z',"")
					let time = this.getDiffDate(startDate,endDate)
					for (let i = 0; i < time.length; i++) {
						this.$set(this.titles, i, time[i])
					}
					break;
				case "year":
					this.titles = []
					for (let i = 0; i < 12; i++) {
						this.$set(this.titles, i, i + 1 + '月')
					}
					break;
			}
		},
		computed: {
			dateName(){
				switch (this.range) {
					case 'day':
						this.timeDate = dateFormat("YY-mm-dd", new Date(this.date))
						return "日"
						break;
					case 'week':
						this.timeDate = dateFormat("YY-mm-dd", new Date(this.date))
						return "周"
						break;
					case 'month':
						this.timeDate = dateFormat("YY-mm", new Date(this.date))
						return "月"
						break;
					case 'year':
						this.timeDate = dateFormat("YY", new Date(this.date))
						return "年"
						break;
					default:
						return "日"
						break;
				}
			},
			selProjectName() {
				return this.$store.getters.selProjectInfo.projectName;
			},
			propsData(){
				return [
					this.date,
					this.range,
					this.loops,
					this.node
				]
			},
			diagramStatus(){
				return this.$store.state.project.diagramStatus
			},
			type(){
				let obj = this.list.filter(e=>e.class==this.node)
				return obj[0]
			}
		},
		watch: {
			propsData(){
                switch (this.range) {
                    case "day":
                        this.titles = []
                        for (let i = 0; i < 24; i++) {
                            this.$set(this.titles, i,  i + '点')
                        }
                        break;
                    case "month":
                        this.titles = []
                        for (let i = 0; i < monthDays(this.date); i++) {
                            this.$set(this.titles, i, i + 1 + '日')
                        }
                        break;
                    case "week":
                        this.titles = []
						let startDate = weekStart(this.date).replace('T00:00:00Z',"")
						let endDate = weekEnd(this.date).replace('T00:00:00Z',"")
						let time = this.getDiffDate(startDate,endDate)
                        for (let i = 0; i < time.length; i++) {
                            this.$set(this.titles, i, time[i])
                        }
                        break;
                    case "year":
                        this.titles = []
                        for (let i = 0; i < 12; i++) {
                            this.$set(this.titles, i, i + 1 + '月')
                        }
                        break;
                }
				
				this.requestData();
            },
			diagramStatus(n){
				if(this.$route.query.uid === 'Complex' ){
					if(n.type === 'excel' && this.tableData.length > 0){

						let data = [
							['名称', '总'+this.type.name+'电量']
						]

						this.titles.forEach(t => {
							data[0].push(t)
						})

						this.tableData.forEach(d => {
							data.push([d.name, d.total, ...this.titles.map(t => d[t]!='--'?d[t]+'kWh':'--')])
						})
						// exportExcel(data, '用'+this.type.name+'量时段报表', [])
						const workbook = new ExcelJS.Workbook();
						// 创建带有红色标签颜色的工作表
						const sheet = workbook.addWorksheet('Sheet1');

						let letter = ['A','B','C','D','E','F','G','H','I','J','K','L','M','N','O','P','Q','R','S','T','U','V','W','X','Y','Z','AA','AB','AC','AD','AE','AF','AG','AH','AI']
						
						let sheetName = ["用"+this.type.name+"时段"+this.dateName+"报表",this.selProjectName,'日期：'+this.timeDate]

						let style =  {
							fill: {
								type: 'gradient',
								gradient: 'angle',
								degree: 0,
								stops: [
								{ position: 0, color: { argb: 'd9d9d9' } },//单元格渐变色（左） 
								{ position: 0.5, color: { argb: 'd9d9d9' } },//单元格渐变色（中）
								{ position: 1, color: { argb: 'd9d9d9' } }//单元格渐变色（右）
								]
							},
							font20:{
								name: 'Arial',
								size: 20,
								bold: true
							},
							font12bold:{
								name: 'Arial',
								size: 12,
								bold: true
							},
							font12:{
								name: 'Arial',
								size: 12,
								// bold: true
							},
							alignmentCenter:{ vertical: 'middle', horizontal: 'center' },
							alignmentLeft:{ vertical: 'middle', horizontal: 'left' },
							border:{
								top: {style:'thin'},
								left: {style:'thin'},
								bottom: {style:'thin'},
								right: {style:'thin'}
							}
						}
						
						if(this.range == 'day'){
							letter = letter.filter((e,i)=>i<26)
						}else if(this.range == 'week'){
							letter = letter.filter((e,i)=>i<9)
						}else if(this.range == 'month'){
							letter = letter.filter((e,i)=>i<monthDays(this.date)+2)
						}else{
							letter = letter.filter((e,i)=>i<14)
						}

						//处理一二层
            
						sheet.mergeCells(letter[0]+'1:'+letter[letter.length-1]+'1');
						sheet.getCell(letter[0]+'1').value = sheetName[0]
						sheet.getCell(letter[0]+'1').font = style.font20
						sheet.getCell(letter[0]+'1').alignment = style.alignmentCenter
						
						sheet.mergeCells('A2:B2');
						sheet.mergeCells('C2:'+letter[letter.length-1]+'2');
						sheet.getCell('A2').value = sheetName[1]
						sheet.getCell('C2').value = sheetName[2]
						sheet.getRow(2).font=style.font12bold
						sheet.getRow(2).alignment = style.alignmentLeft
						const rows = sheet.getRows(1, 2);
						rows.map(e=>{e.height = 50 ;return e})


						//表格设置
						let columns = []
						data[0].forEach(item=>{
							columns.push({
								name:item,
							})
						})
						sheet.addTable({
							name: 'MyTable',
							ref: 'A3', // 表格左上角的位置
							headerRow: true,
							totalsRow: false,
							style: {
								theme: 'TableStyleLight1',
								font:{
									name: 'Arial',
									size: 12,
									// bold: true
								},
							},
								//            showRowStripes: true,
							columns:columns,
							rows: data.slice(1),
						})

						//表格头部样式
						sheet.getRow(3).height = 59
						sheet.getRow(3).font=style.font12bold
						
						letter.forEach(item=>{
							sheet.getCell(item+'3').fill = style.fill
							sheet.getCell(item+'3').border = style.border
							sheet.getRow(3).alignment = style.alignmentCenter
						})
						data.slice(1).forEach((item,index)=>{
							sheet.getRow(4+index).height = 38
							sheet.getRow(4+index).font=style.font12
							letter.forEach((e,i)=>{
								if(i<=1){
									sheet.getColumn(e).width = 26
								}else{
									sheet.getColumn(e).width = 14
								}
								sheet.getCell(e+(4+index)).border = style.border
							})
						
							sheet.getRow(4+index).alignment = style.alignmentCenter
						})
						

						// workbook.xlsx.writeFile('test.xlsx')
						workbook.xlsx.writeBuffer().then(buffer => {
							FileSaver.saveAs(new Blob([buffer], { type: 'application/octet-stream' }), `${sheetName[0]}.xlsx`);
						})

					}else {
						this.$message.warning("无图表数据！")
					}
				}
			},
			// node(){
			// 	this.type = this.class();
			// }
		},
		methods: {
			// class(){
			// 	switch (this.node) {
			// 		case 'electricity':
			// 			return '电'
			// 			break;
			// 		case 'water':
			// 			return '水'
			// 			break;
			// 		case 'heat':
			// 			return '热'
			// 			break;
			// 		case 'cooling':
			// 			return '冷'
			// 			break;
			// 		default:
			// 			return '电'
			// 			break;
			// 	}
			// },
			//数据
			async requestData(){
				this.loading = true;
				let range = this.range;
				let node = this.node;
				let promises = [];
				let currList = this.loops;
				currList.forEach((element) => {
					let obj = {
					buildingId: element.id,
					date: dateFormat("YY-mm-dd", this.date) + "T00:00:00Z",
					powerType: node.toUpperCase(),
					range: range.toUpperCase(),
					};
					promises.push(classifiedEnergyConsumption(obj));
				});
				let list = []
				Promise.all(promises).then((res) => {
					let pointsArray = res.map((r) =>
					r.data.data.result ? r.data.data.result : {}
					);
					pointsArray.forEach((item, index) => {
						let arr = item[node]
						let data = {
							name:this.loops[index].name,
							total:0,
							id:this.loops[index].id
						}
						let num = 0
						this.titles.forEach((e,i)=>{
							data[e] = arr[i]!=null?Number(arr[i]).toFixed(2)+" "+this.type.unit:"--"
							if(arr[i]){
								num +=arr[i]
							}
						})
						data.total = Number(num).toFixed(2)+" "+this.type.unit
						list.push(data)
					});
					this.loading = false;
					this.tableData = list
				});
			},
			getDate(datestr) {
				var temp = datestr.split("-");
				if (temp[1] === '01') {
					temp[0] = parseInt(temp[0],10) - 1;
					temp[1] = '12';
				} else {
					temp[1] = parseInt(temp[1],10) - 1;
				}
				var date = new Date(temp[0], temp[1], temp[2]);
				return date;
			},
			getDiffDate (start, end) {
				var startTime = this.getDate(start);
				var endTime = this.getDate(end);
				var dateArr = [];
				while ((endTime.getTime() - startTime.getTime()) >= 0) {
					var year = startTime.getFullYear();
					var month = (startTime.getMonth()+1).toString().length === 1 ? "0" + (parseInt(startTime.getMonth().toString(),10) + 1) : (startTime.getMonth() + 1);
					var day = startTime.getDate().toString().length === 1 ? "0" + startTime.getDate() : startTime.getDate();
					dateArr.push(year + "-" + month + "-" + day);
					startTime.setDate(startTime.getDate() + 1);
				}
				return dateArr;
			}
		},
	}
</script>

<style scoped lang="less">
	.tip {
		width: 100%;
		height: 100%;
		font-size: 16rem;
		color: #8c939d;
	}

	.loading {
		width: 28rem;
		height: 28rem;
		animation: loading 1s linear infinite;
	}

	@keyframes loading {
		0% {
			transform: rotate(0);
		}
		100% {
			transform: rotate(360deg);
		}
	}
</style>